/**
* @Description: 测试题组件
* @author wangshu
* @date 2020/4/2
*/
<template>
  <div class="wrap">
    <!-- 测试 -->
    <transition name="el-fade-in" mode="out-in">
      <PopTest v-if="showComparison&&!testResult">
        <template slot="header">
          <div class="pop-title td-fsc">
            <span>{{option.name}}</span>
            <span v-if="dataSource.edition_name">-【{{dataSource.edition_name}}</span>
            <span v-if="dataSource.unit_name">-{{dataSource.unit_name}}】</span>
          </div>
          <div class="pop-btn-test td-fsc">
            <span class="time">{{countDown}}</span>
            <img
              class="btn"
              v-if="closeType == 1"
              :src="GLOBAL.Images.dialog_quit"
              @click="closePaper"
            />
            <img class="btn" v-else :src="GLOBAL.Images.dialog_close" @click="closeDialog" />
          </div>
        </template>
        <template slot="content">
          <div v-if="isTestQuestion && loading" class="grammar-content-box">
            <div class="select-box">
              <div
                class="topic-title"
                v-if="dataSource.subject1&&JSON.stringify(dataSource.subject1) != '[]'"
              >
                <span>【选择】</span>
              </div>
              <div class="question-list" v-for="(item,index) in dataSource.subject1" :key="index">
                <div class="question-box">
                  <div
                    class="question"
                    :class="[item.result==1?'error-bg':'',item.result==0?'success-bg':'']"
                    v-html="putProblem(item.subject)"
                  ></div>
                  <div class="question-radio">
                    <el-radio-group v-model="item.radio" size="medium">
                      <el-radio
                        :label="item.option_one"
                        :class="item.result==1&&item.answer==item.option_one?'error-color':''"
                      >{{item.option_one}}</el-radio>
                      <el-radio
                        :label="item.option_two"
                        :class="item.result==1&&item.answer==item.option_two?'error-color':''"
                      >{{item.option_two}}</el-radio>
                      <el-radio
                        :label="item.option_three"
                        :class="item.result==1&&item.answer==item.option_three?'error-color':''"
                      >{{item.option_three}}</el-radio>
                      <el-radio
                        :label="item.option_four"
                        :class="item.result==1&&item.answer==item.option_four?'error-color':''"
                      >{{item.option_four}}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="answer" v-if="item.result==1">
                  <div>答案解析：</div>
                  <div>{{item.analysis}}</div>
                </div>
              </div>
            </div>
            <div class="select-box">
              <div
                class="topic-title"
                v-if="dataSource.subject2&&JSON.stringify(dataSource.subject2) != '[]'"
              >
                <span>【听写】</span>
              </div>
              <div class="dictation-wrap">
                <div class="dictation-box" v-for="(item,index) in dataSource.subject2" :key="index">
                  <div
                    class="dictation"
                    :class="[item.result==1?'error-bg':'',item.result==0?'success-bg':'']"
                  >
                    <img
                      src="@/assets/img/grammarTest/voice_test.png"
                      @click.stop="playAudio(`eventAudio+${index}`)"
                      alt
                    />
                    <audio :id="`eventAudio+${index}`" :src="item.voice"></audio>
                    <span v-html="putProblem(item.subject,index)"></span>
                    <div v-for="(i,num) in item.answer_num" :key="i">
                      <div class="dictation-answer" v-if="item.result==1">{{item.answer[num]}}</div>
                    </div>
                  </div>
                  <div>
                    <div class="show-hint">
                      <el-button
                        style="background: #00BFCC;color: #fff;font-size: 16px;"
                        size="small"
                        @click="showReminder(index)"
                      >词义显示</el-button>
                      <transition name="el-fade-in" mode="out-in">
                        <div class="hint" v-if="item.answerSwitch">{{item.meaning}}</div>
                      </transition>
                    </div>
                  </div>
                  <div class="dictation-input">
                    <div v-for="(i,num) in item.answer_num" :key="num">
                      <el-input placeholder="请输入内容" v-model="item['input_'+num]" clearable></el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="push">
              <el-button v-if="endTest==false" type="success" @click="pushPaper()">交卷</el-button>
              <el-button v-else type="success" @click="close()">关闭</el-button>
            </div>
            <!-- 遮罩 -->
            <div class="blank-shade" v-if="isError"></div>
          </div>
          <div v-if="!isTestQuestion" class="hint-text" key="xxx">
            <div>
              <div class="hint-box">
                <div>{{message||'没有相关测试题~~~'}}</div>
              </div>
              <div class="foot-btn" style="margin-top: 20px;">
                <el-button type="danger" @click="close()">关闭窗口</el-button>
              </div>
            </div>
          </div>
        </template>
      </PopTest>
    </transition>

    <!-- 结果 -->
    <transition name="el-fade-in" mode="out-in">
      <PopTest v-if="testResult">
        <template slot="header">
          <div class="pop-title td-fsc">
            <span>{{option.name}}</span>
          </div>
        </template>
        <template slot="content">
          <div class="grammar-content-box result-box">
            <div class="result-title">
              <img src="../../../../assets/img/grammarTest/test_paper.png" alt />
              <div>{{resultData.curriculum}}</div>
              <div>（题量：{{dataSource.total}}）</div>
            </div>
            <div class="result-info-1">
              <div>
                答对：
                <span style="color: #01B59E">{{writeNum+selectNum}}</span>题
              </div>
              <div>
                答错：
                <span style="color: #D0021B">{{dataSource.total-(writeNum+selectNum)}}</span>题
              </div>
              <div>
                用时：
                <span style="color:#FF6211">{{formatSeconds(useTime)}}</span>
              </div>
            </div>
            <div class="result-info-2">
              您已掌握本学学段语法量
              <span style="color:#FF6211;font-size: 35px;">{{resultData.success}}%</span>
            </div>
            <div class="result-info-2">
              您还有
              <span style="color:#FF6211;font-size: 35px;">{{resultData.error}}</span>%没有掌握哦，继续加油呢!
            </div>
            <div class="result-info-2">
              获得
              <span style="color:#FF6211;font-size: 35px;">{{resultData.power_stone}}</span>能量石，全国排名
              <span style="color:#FF6211;font-size: 35px;">{{resultData.level}}</span>名！
            </div>
            <div class="hint-box">
              <div>
                <div>
                  <img v-show="resultData.is_pass==1" src="@/assets/img/test/icon_good.png" alt />
                </div>
                <div>Pass</div>
              </div>
              <div>
                <div>
                  <img v-show="resultData.is_pass==0" src="@/assets/img/test/icon_good.png" alt />
                </div>
                <div>Fail</div>
              </div>
            </div>
            <div class="pop-btn">
              <el-button type="warning" @click="testReport=true">学习报告</el-button>
              <el-button type="danger" @click="close()">退出测试</el-button>
            </div>
          </div>
        </template>
      </PopTest>
    </transition>

    <!--查看报告-->
    <transition name="el-fade-in" mode="out-in">
      <PopTest v-if="testReport">
        <template slot="header">
          <div class="pop-title td-fsc">
            <span>{{option.name}}</span>
          </div>
        </template>
        <template slot="content">
          <div class="grammar-content-box user-box">
            <div class="info-title">
              <img src="../../../../assets/img/grammarTest/dota2.png" alt />
              学员信息
            </div>
            <div class="user-info">
              <img v-if="userInfo.avatar" :src="userInfo.avatar" alt class="img-box" />
              <img v-else src="../../../../assets/img/teacher/head_photo.png" alt class="img-box" />
              <div class="right-info">
                <div>账户：{{userInfo.emp_no|| userInfo.realname}}</div>
                <div>测试时间：{{resultData.test_time}}</div>
              </div>
            </div>
            <div class="info-title">
              <img src="../../../../assets/img/grammarTest/dota2.png" alt />
              测试信息
            </div>
            <div class="info-list">
              <div>
                <div>测试类型：</div>
                <div>{{resultData.test_type}}</div>
              </div>
              <div>
                <div>得分：</div>
                <div>{{resultData.achievement}}分</div>
              </div>
              <div>
                <div>答对：</div>
                <div>{{writeNum+selectNum}}题</div>
              </div>
              <div>
                <div>答错：</div>
                <div>{{dataSource.total-(writeNum+selectNum)}}题</div>
              </div>
              <div>
                <div>用时：</div>
                <div>{{formatSeconds(useTime)}}</div>
              </div>
              <div>
                <div>获得能量石数：</div>
                <div>{{resultData.power_stone}}个</div>
              </div>
              <div>
                <div>全国排名：</div>
                <div>{{resultData.level}}名</div>
              </div>
              <div>
                <div>掌握学段：</div>
                <div>{{resultData.success}}%</div>
              </div>
              <div>
                <div>推荐课程：</div>
                <div>{{resultData.curriculum}}</div>
              </div>
            </div>
            <div class="foot-btn">
              <el-button type="success" @click="seeError">查看错误</el-button>
              <el-button type="danger" @click="close()">关闭窗口</el-button>
            </div>
          </div>
        </template>
      </PopTest>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import Lockr from "lockr";
import {
  userInfo
} from "@/api/user";
import {
  pushPaper,
  unitTest,
  selfTest,
  selfPushPaper,
  comparisonTest,
  PushComparisonTest,
  unitDictation,
  pushUnitDictation,
  bookTest,
  pushBookTest,
} from "@/api/grammar";

export default {
  name: "testPaper",
  props: ["showComparison", "type", "option", "closeType"],
  computed: {
    ...mapGetters(['userInfo'])
  },
  data() {
    return {
      loading: false,
      isTestQuestion: true,
      testResult: false, //显示结果
      isError: false, //查看错误
      dataSource: "",
      selectNum: 0,
      writeNum: 0,
      timer: "", //计时器
      countDown: "", //倒计时
      useTime: "", //使用时长
      resultData: "", //测试结果
      testReport: false, //学习报告
      endTest: false, //交卷之后隐藏，交卷按钮
      message: "", //提示语
      dictationAnswer: [], //单元听写交卷的数组
    };
  },
  methods: {
    getTestPaper() {
      if (this.type == 1) {
        let params = {
          token: Lockr.get("token"),
          unit_id: this.option.testPaperId,
        };
        unitTest(params).then((res) => {
          this.dataOption(res);
        });
      }

      if (this.type == 2) {
        let params = {
          token: Lockr.get("token"),
          unit_id: this.option.testPaperId,
          is_select: this.option.is_select,
          is_write: this.option.is_write,
          num: this.option.grammarNum,
        };
        selfTest(params).then((res) => {
          this.dataOption(res);
        });
      }
      if (this.type == 3) {
        let params = {
          token: Lockr.get("token"),
          unit_id: this.option.testPaperId,
          category: this.option.category,
        };
        comparisonTest(params).then((res) => {
          this.dataOption(res);
        });
      }
      if (this.type == 4) {
        let params = {
          token: Lockr.get("token"),
          unit_id: this.option.testPaperId,
        };
        unitDictation(params).then((res) => {
          this.dataOption(res);
        });
      }
      if (this.type == 5) {
        let params = {
          token: Lockr.get("token"),
          is_select: this.option.is_select,
          is_write: this.option.is_write,
          curriculum_id: this.option.testPaperId,
        };
        bookTest(params).then((res) => {
          if (res.data == "") {
            this.message = res.msg;
          }
          this.dataOption(res);
        });
      }
    },
    //格式化数据13
    dataOption(res) {
      if (res.data.total > 0) {
        this.dataSource = res.data;
        this.minReturn(this.dataSource.time);
        if (this.dataSource.subject1) {
          if (res.data.subject1&&!res.data.subject1.length&&res.data.subject2&&!res.data.subject2.length) {
            this.isTestQuestion = false;
            return;
          }
          this.dataSource.subject1.forEach((item, index) => {
            this.$set(this.dataSource.subject1[index], "radio", "");
          });
        }
        if (this.dataSource.subject2) {
          if (res.data.subject1&&!res.data.subject1.length&&res.data.subject2&&!res.data.subject2.length) {
            this.isTestQuestion = false;
            return;
          }
          this.dataSource.subject2.forEach((item, index) => {
            // 填空数量
            let anser_num = item.answer_num;
            for (let i = 0; i < anser_num; i++) {
              this.$set(this.dataSource.subject2[index], "input_" + i, "");
              this.$set(this.dataSource.subject2[index], "answerSwitch", false);
            }
          });
        }
        this.isTestQuestion = true;
        this.loading = true
      } else {
        this.isTestQuestion = false;
      }
    },
    //播放声音
    playAudio(e) {
      let buttonAudio = document.getElementById(e);
      buttonAudio.play();
    },
    //交卷 && 对比答案
    pushPaper() {
      this.endTest = true;
      this.timer && clearInterval(this.timer);
      this.comparison();
      let params = {
        token: Lockr.get("token"),
        unit_id: this.dataSource.unit_id,
        total_num: this.dataSource.total,
        select_num: this.selectNum,
        write_num: this.writeNum,
        test_time: this.dataSource.time,
        use_time: this.useTime,
      };
      if (this.type == 1) {
        pushPaper(params).then((res) => {
          if (res.code == 1) {
            this.resultData = res.data;
          }
        });
        this.testResult = true;
      }
      if (this.type == 2) {
        selfPushPaper(params).then((res) => {
          if (res.code == 1) {
            this.resultData = res.data;
          }
        });
        this.testResult = true;
      }
      if (this.type == 3) {
        params.category = this.option.category;
        PushComparisonTest(params).then((res) => {
          if (res.code == 1) {
            this.resultData = res.data;
          }
        });
        this.testResult = true;
      }
      //  单元听写
      if (this.type == 4) {
        params.curriculum_id = this.option.testPaperId;
        params.answer = this.dictationAnswer;
        pushUnitDictation(params).then((res) => {
          if (res.code == 1) {
            this.resultData = res.data;
          }
        });
        this.testResult = true;
      }
      if (this.type == 5) {
        params.unit_id = this.option.testPaperId;
        pushBookTest(params).then((res) => {
          if (res.code == 1) {
            this.resultData = res.data;
          }
        });
        this.testResult = true;
      }
    },
    //对照答案
    comparison() {
      if (this.dataSource.subject1) {
        this.dataSource.subject1.map((item, index) => {
          if (item.radio != item.answer) {
            this.$set(item, "result", "1"); //错误
          } else {
            this.$set(item, "result", "0"); //正确
            this.selectNum++;
          }
        });
      }
      if (this.dataSource.subject2) {
        this.dataSource.subject2.map((item, index) => {
          let answer_num = item.answer_num;
          for (let i = 0; i < answer_num; i++) {
            if (item.answer[i] != item["input_" + i]) {
              this.$set(item, "result", "1"); //错误
              this.$set(item, "answerInfo", "0"); //错误
            } else {
              this.$set(item, "result", "0"); //正确
              this.$set(item, "answerInfo", "1"); //正确
              if (i == 0) this.writeNum++;
            }
          }
          // 单元听写记录答案
          if (this.type == 4) {
            this.dictationAnswer.push(item.answerInfo);
          }
        });
      }
    },

    //查看错误
    seeError() {
      this.testResult = false;
      this.isError = true;
      this.testReport = false;
    },
    // 关闭测试弹窗
    closeDialog() {
      this.timer && clearInterval(this.timer);
      this.$emit("closeComparison");
    },
    // 关闭结果页
    close() {
      this.testResult = false;
      this.testReport = false;
      this.endTest = false;
      this.$emit("closeComparison");
    },
    //   格式化题目
    putProblem(data) {
      let issue = data.split("()");
      let newIssue = "";
      issue.forEach((item, index) => {
        newIssue += issue[index];
        if (index != issue.length - 1) {
          newIssue += `<span class="fill-in">____</span>`;
        }
      });
      return newIssue;
    },
    //格式化时间
    formatBit(val) {
      val = +val;
      return val > 9 ? val : "0" + val;
    },
    // 秒转时分秒，求模很重要，数字的下舍入
    formatSeconds(time) {
      let min = Math.floor(time % 3600);
      let val =
        this.formatBit(Math.floor(time / 3600)) +
        ":" +
        this.formatBit(Math.floor(min / 60)) +
        ":" +
        this.formatBit(time % 60);
      return val;
    },
    // 定时器
    minReturn(time) {
      this.timer = setInterval(() => {
        time--;
        this.useTime++;
        this.countDown = this.formatSeconds(time);
        if (this.countDown == "00:00:00") {
          //自动交卷
          this.pushPaper();
          clearInterval(this.timer);
        }
        if (time <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    //词义显示
    showReminder(index) {
      this.$set(this.dataSource.subject2[index], 'answerSwitch', !this.dataSource.subject2[index].answerSwitch)
    },
  },
};
</script>

<style scoped lang='less'>
.wrap {
  .blank-shade{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 160px;
    right: 0;
    z-index: 2;
  }
  .left-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    > div:nth-of-type(1) {
      display: flex;
      align-items: center;

      p {
        font-size: 18px;
      }

      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
    }

    .countDown {
      background: url("../../../../assets/img/grammarTest/time_bg.png");
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      width: 50px;
      height: 50px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .grammar-content-box {
    transition: all 0.5s;
    position: relative;
    background: #f4f4f8;
    position: relative;
    .select-box {
      .topic-title {
        height: 40px;
        line-height: 40px;
        background: #21d23a;
        padding: 0 10px;
        color: #fff;
        font-size: 22px;
        margin-bottom: 20px;
      }
    }

    .question-list {
      margin: 0 35px;

      .question-box {
        padding: 15px 0 0;

        .question {
          background: #fedf67;
          font-size: 26px;
          line-height: 30px;
          padding: 6px 15px;
          align-items: center;
          text-align: justify;

          img {
            width: 25px;
            height: 20px;
            cursor: pointer;
          }
        }

        .error-color {
          color: #ff9297;
        }

        .error-bg {
          background: #ff9297;
        }

        .success-bg {
          // background: #21d23a;
        }
      }

      .answer {
        padding: 10px 21px 15px 21px;
        background: #ede1d9;
        font-size: 16px;
        margin-bottom: 20px;

        > div:nth-of-type(1) {
          color: #fa4860;
          margin-bottom: 10px;
        }

        > div:nth-of-type(2) {
          color: #333333;
        }
      }
    }

    .question-list:not(:last-child) {
      border-bottom: 3px solid #cdcdcd;
    }

    .dictation-box {
      margin: 15px 20px;
      background: #fff;

      .dictation {
        background: #fedf67;
        font-size: 26px !important;
        padding: 6px 15px;
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
          width: 30px;
          height: 30px;
          margin-right: 10px;
        }

        .dictation-answer {
          border-radius: 15px;
          padding: 3px 15px;
          background: #fff;
          margin-left: 20px;
          color: #fa4860;
        }
      }

      .error-color {
        color: #ff9297;
      }

      .error-bg {
        background: #ff9297;
      }

      .success-bg {
        // background: #21d23a;
      }

      .show-hint {
        display: flex;
        align-items: center;
        margin-top: 15px;
        padding: 0 15px;

        .hint {
          font-size: 20px;
          margin-left: 20px;
        }
      }

      .dictation-input {
        padding: 10px 0;
        /deep/ .el-input__inner{
          font-size: 18px;
        }
        > div {
          padding: 5px 15px;
        }
      }
    }

    .push {
      text-align: center;
      background: #f4f4f8;
      padding: 65px 0 60px 0;

      .el-button--success {
        padding: 10px 50px;
        font-size: 18px;
        font-weight: bold;
      }
    }
  }

  .hint-text {
    position: relative;
    height: 450px;
    text-align: center;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .hint-box {
      padding: 60px 180px;
      box-shadow: 0px 1px 12px 3px rgba(0, 0, 0, 0.08);
    }

    > div:nth-of-type(2) {
      color: #ff626f;
      margin: 5px 0;
    }
  }

  .summary-box {
    max-height: 700px;
    z-index: 32;
  }

  .result-box {
    border: none !important;
    overflow-y: auto !important;
    display: flex;
    align-items: center;
    flex-direction: column;

    .result-title {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 23px;
      margin: 20px 0;

      > div:nth-of-type(2) {
        font-size: 20px;
      }

      img {
        width: 26px;
      }
    }

    .result-info-1 {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;

      > div {
        margin: 0 15px;
        font-size: 20px;
        font-weight: bold;
      }
    }

    .result-info-2 {
      font-size: 28px;
      color: #47c149;
      margin-bottom: 10px;
    }

    .hint-box {
      display: flex;
      flex-direction: column;
      align-items: center;

      > div {
        display: flex;
        width: 300px;
        margin: 10px 0;
        padding-left: 150px;

        > div:nth-of-type(1) {
          width: 40px;
          height: 40px;
          background: #fff;
          border: 2px solid #00598d;
          margin-right: 20px;

          img {
            width: 120%;
            height: 100%;
          }
        }

        > div:nth-of-type(2) {
          font-size: 38px;
          font-weight: bold;
          color: #47c149;
        }
      }

      > div:nth-of-type(2) {
        > div:nth-of-type(2) {
          color: #ff5100;
        }
      }
    }

    .pop-btn {
      margin: 20px 0;
    }
  }

  .user-box {
    border: none !important;
    overflow-y: auto !important;
    display: flex;
    flex-direction: column;
    padding: 0 115px;

    .info-title {
      display: flex;
      font-size: 20px;
      font-weight: bold;

      img {
        width: 30px;
        height: 30px;
        object-fit: contain;
        margin-right: 10px;
      }
    }

    .user-info {
      display: flex;
      align-items: center;
      padding: 10px 0;
      border-bottom: 1px solid #dcdcdc;
      margin-bottom: 20px;

      .img-box {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        margin-right: 35px;
      }

      .right-info {
        > div {
          margin: 10px 0;
          font-size: 18px;
        }

        .name {
          font-size: 24px;
          font-weight: 600;
        }
      }
    }

    .info-list {
      border-bottom: 1px solid #dcdcdc;

      > div {
        display: flex;
        font-size: 20px;
        margin: 15px 0;
        padding: 0 20px;

        > div:nth-of-type(1) {
          width: 240px;
        }
      }
    }

    .foot-btn {
      margin: 20px 0;
      text-align: center;
    }
  }

  .error-box {
    .error-option {
      color: #fa4860;
    }

    .answer {
      background: #fff;
      padding: 10px 20px;
      font-size: 16px;

      .answer-title {
        color: #fa4860;
      }

      .answer-text {
        color: #333333;
        margin-top: 10px;
      }
    }
  }

  .shade2 {
    background-color: #000000;
    opacity: 0.4;
    z-index: 32;
  }

  .el-radio-group {
    width: 100%;
    padding: 10px 0;
    .el-radio {
      padding: 6px 10px;
      height: 28px;
      margin: 0;
      color: #000;
      display: flex;
      align-items: center;
    }

    .el-radio:hover {
      transition: all 0.3s;
      background: #d9ecff;

      .el-radio__label {
        display: inline-block;
        width: 100%;
      }
    }
  }
}
@media (max-width: 1198px) {
  .user-box {
    font-size: 16px;

    .info-title {
      font-size: 16px;

      img {
        width: 20px;
        height: 20px;
      }
    }

    .info-list {
      div {
        font-size: 16px;
        margin: 3px 0;
      }
    }

    .user-info {
      margin-top: 10px;

      .img-box {
        width: 60px;
        height: 60px;
      }

      .right-info {
        div {
          margin: 3px 0;
        }
      }
    }
  }
}
</style>